import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { FlexBox } from '../layouts/FlexBox';
import { Text } from '../texts/Text';
const ResponsiveFlexBox = styled(FlexBox)`
  @media (max-width: 595px) {
    flex-direction: column;
  }
`;
const RowLabel = styled.span`
  label: JMT-General-RowLabel;
  font-size: 16px;
  line-height: 16px;
  flex: 1;
  padding: 10px 0;
  @media (max-width: 595px) {
    padding-bottom: 0px;
  }
`;
const RowValue = styled.span`
  font-size: 16px;
  line-height: 16px;
  flex: 2;
  padding: 10px 0;
`;
export const RowItem = ({
  label,
  value
}) => React.createElement(ResponsiveFlexBox, null, React.createElement(RowLabel, null, React.createElement(Text, {
  isBold: true
}, label)), React.createElement(RowValue, null, value));
RowItem.propTypes = {
  label: PropTypes.node.isRequired,
  value: PropTypes.node.isRequired
};